/* this is the custom selectmenu widget extension add multiline and css theming support */



/* custom selectmenu widget: multiline + css theming + a11y accessible name */

var multilineSelectmenu = $.widget("ui.multilineSelectmenu", $.ui.selectmenu, {
    _setText: function (element, value) {
        if (value) {
            if (value.indexOf('|') !== -1) {
                var lines = value.split('|');
                value = '<span class="ui-selectmenu-menu-item-header">' + lines[0].trim() + '</span>';
                var newvalue = value.replace('(', '<span class="smalltext wow">(');
                var newvalue2 = newvalue.replace(')', ')</span>');
                for (var i = 1; i < lines.length; i++) {
                    value = newvalue2 + '<span class="ui-selectmenu-menu-item-content">' + lines[i].trim() + '</span>';
                }
            }
            element.html(value);
        } else {
            element.html("&#160;");
        }
    },

    _applyAccessibleName: function () {
        var selectId = this.element.attr("id");
        var $label = $('label[for="' + selectId + '-button"]');

        if ($label.length) {
            var labelId = $label.attr("id");
            if (!labelId) {
                labelId = selectId + "-a11y-label";
                $label.attr("id", labelId);
            }
            this.button.attr("aria-labelledby", labelId);
        } else {
            var name = this.element.attr("title") ||
                       this.element.find("option:selected").text().trim() ||
                       "Select option";
            this.button.attr("aria-label", name);
        }
        // Stale reference on a collapsed combobox — remove until menu opens.
        this.button.removeAttr("aria-activedescendant");
    },

    refresh: function () {
        this._super();
        this._applyAccessibleName();
    },

    _create: function () {
        this._super();
        this._applyAccessibleName();
    }
});